import React from 'react'
import {injectIntl} from 'react-intl'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import Button from '@mui/material/Button'
import TextField from '@mui/material/TextField'
import Dialog from 'components/Dialog'

class LinkDialog extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            url: props.value
        }
    }

    handleConfirm = () => {
        this.props.handleConfirm({url: this.state.url})
    }

    handleDelete = () => {
        this.props.handleConfirm()
    }

    handleChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        })
    }

    render() {
        const {intl} = this.props

        return (
            <Dialog open={this.props.open} onClose={this.props.handleClose}>
                <DialogTitle>
                    {intl.formatMessage({id: "editor.link_settings"})}
                </DialogTitle>
                <DialogContent>
                    <TextField variant="standard"
                        style={{width: '100%'}}
                        defaultValue={this.state.url}
                        onChange={this.handleChange}
                        label={intl.formatMessage({id: "editor.url"})}
                        InputLabelProps={{
                            shrink: true
                        }}
                        inputProps={{
                            name: 'url'
                        }}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.props.handleClose} color="primary">
                        {intl.formatMessage({id: "app.confirm_cancel"})}
                    </Button>
                    {this.props.value &&
                        <Button onClick={this.handleDelete}
                            variant="contained"
                            color="secondary"
                        >
                            {intl.formatMessage({id: "app.confirm_delete"})}
                        </Button>
                    }
                    <Button onClick={this.handleConfirm}
                        disabled={this.state.url.replace(/\s/g, '') === ''}
                        variant="contained"
                        color="primary"
                    >
                        {intl.formatMessage({id: "app.confirm_save"})}
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }
}

export default injectIntl(LinkDialog)
